import { h } from 'preact';
import tags from 'react-tag-names';
import picostyle from './picostyle';

const ps = picostyle(h);

export const restyle = ps;

const isObject = val => typeof val === 'object' && val !== null;
const isFunction = val => typeof val === 'function';

const errorMsg = `Invalid arguments supplied. You must provide either:
1. a styles object, eg: { color: 'red' }
2. a styles function, eg: (props) => ({ color: props.color })
3, a styles object (arg 1) and a styles function (arg 2)`;

const styled = tags.reduce((accum, tag) => (
  {
    ...accum,
    [tag]: (stylesA, stylesB) => {
      if (stylesB === undefined) {
        return ps(tag)(stylesA);
      }

      if (isObject(stylesA) && isFunction(stylesB)) {
        return ps(tag)(props => ({ ...stylesA, ...stylesB(props) }));
      }

      throw new Error(errorMsg);
    },
  }), {});

export default styled;
